module.exports = __webpack_public_path__ + "static/media/icon-water-heating.7954e61f.svg";